import config from '@/config';
import React from 'react';
import { LiveChatWidget } from '@livechat/widget-react';

interface LiveChatProps {
  isSupportPage: boolean;
}

const LiveChat: React.FC<LiveChatProps> = ({ isSupportPage }) => {
  if (!config.livechatLicense || !isSupportPage) {
    return <></>;
  }

  return <LiveChatWidget license={config.livechatLicense} />;
};

export default React.memo(LiveChat);
